<template>
  <div>
    <div class="card-title h5">4. {{ $t('tabs.title_selection.description') }}</div>
      <div class="tab-pane active" id="tecnocampus">
        <div class="row">
          <div class="col-sm-12 col-md-offset-1 col-md-10">
            <div class="form-group mb-3">
              <label class="required form-label mb-3">{{ $t('tabs.title_selection.question1') }}</label>


              <table class="table table-sttriped">
                <tbody>
                <tr>
                    <th></th>
                    <th v-for="ponderacio in 11" :key="ponderacio">{{ ponderacio -1 }}</th>
                </tr>
                  <tr v-for="(pregunta, index) in options_seleccio_titulacio" :key="index">
                    <th>{{ pregunta[lang] }}</th>
                    <td v-for="ponderacio in 11" :key="ponderacio">
                      <input type="radio" class="form-check-input" :class="{'input': true, 'is-invalid': errors.has('sel_recomanacio_' + pregunta.id) }"
                             :name="'sel_recomanacio_' + pregunta.id"
                             :value="ponderacio"
                             v-validate="'required|included:1,2,3,4,5,6,7,8,9,10,11'"
                             v-model="sel_recomanacio[pregunta.id]"
                      >
                    </td>
                  </tr>
                  <tr v-show="errors.length > 0">
                    <td colspan="12"><span class="my-invalid-feedback">{{ $t('tabs.title_selection.errors.missing_answers') }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="form-group mb-3">
              <label class="form-label required">{{ $t('tabs.title_selection.question2') }}</label>
              <div class="row">
                <div class="form-check form-check-inline col col-md-6 col-lg-6" v-for="(item, index) in options_com_has_conegut" :key="index" v-show="!item.disabled">
                  <input type="checkbox" class="form-check-input" :class="{'input': true, 'is-invalid': errors.has('com_has_conegut') }"
                         name="com_has_conegut"
                         :value="item.value"
                         v-validate="'required'"
                         v-model="com_has_conegut"
                  >
                  <label class="form-check-label">{{ item[lang] }}</label>
                </div>
                <span v-show="errors.has('com_has_conegut')" class="my-invalid-feedback">{{ errors.first('com_has_conegut') }}</span>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
</template>

<script>
import {list_seleccio_titulacio, list_com_has_conegut} from "@/helpers/data";

export default {
  name: 'per-que-tecnocampus',
  props: { lang: { required:true, default:'ca'} },
  data() {
    return {
      sel_recomanacio: [],
      com_has_conegut: [],
      options_seleccio_titulacio: list_seleccio_titulacio,
      options_com_has_conegut: list_com_has_conegut
    }
  },
  created() {
    this.$validator.localize(this.lang);
  },
  methods: {
    async validate() {
      const result = await this.$validator.validateAll();
      if (!result) {
        return false;
      }
      this.$emit('on-validate', this.$data, true);
      return result;
    }
  }
}
</script>